<template>
  <div class="stockProduct_box">
    <Qrcode-Dialog :instockdia.sync="instockdia" :maincusCode="maincusCode" />
    <dialogPlugin :showProduct.sync='showProduct' :onlineItems="onlineItems" @setVartualSku="setVartualSku" />
    <dialogPlugin :showErrorDeleteItem.sync='showErrorDeleteItem' :listErrorOptions="listErrorOptions"></dialogPlugin>
    <dialogPlugin :openDiaconfigPackage.sync='openDiaconfigPackage' :packageList="packageList"
      :packageInfo="packageInfo">
    </dialogPlugin>
    <dialogPlugin :openDialog.sync="openDialog" :handleParamtype="type" :handleParam="handleParam"
      @createItemNotProduct="createItemNotProduct"></dialogPlugin>
    <dialogPlugin :agentDialog.sync="agentDialog" :agentList="agentList"></dialogPlugin>
    <dialogPlugin :purchaseHistoryDia.sync="purchaseHistoryDia" :purchaseList='purchaseList'></dialogPlugin>

    <el-dialog :visible.sync="dialogTableVisibleTwo" width="80%">
      <div v-if="!isShow">
        <div style=" font-size: 18px;display: flex;justify-content: space-between;margin-bottom: 15px;">
          <div style="display: flex">
            <div style="width: 80px; height: 80px; position: relative">
              <img style="width: 100%" :src="additionItem ? additionItem.image : ''" />
              <span style="position: absolute; top: -28px; left: 0; color: red">{{ $t('other.a2138') }}</span>
            </div>
            <div style="margin: 0 20px">
              <div style="color: #409eff">
                {{ $t('other.a2139') }}：{{ additionItem ? additionItem.skuName : "" }}
              </div>
              <div style="padding: 5px 0; font-size: 14px">
                {{ $t('other.a67') }}：{{ additionItem ? additionItem.cusCode : "" }}
              </div>
              <div style="font-size: 14px">
                skuName：{{ additionItem ? additionItem.variationName : $t('other.a354') }}
              </div>
            </div>
          </div>
          <div>
            <el-button v-show="!isEditGoods" type="primary" @click="isEditGoods = !isEditGoods">{{
              $t('other.a238') }}</el-button>
            <el-button v-show="isEditGoods" type="primary" @click="addGoods">{{ $t('other.a2140') }}</el-button>
            <el-button v-show="isEditGoods" type="danger" @click="saveItems">{{ $t('other.a216') }}</el-button>
            <el-button v-show="isEditGoods" type="primary" @click="isEditGoods = false">{{ $t('other.a146')
            }}</el-button>
          </div>
        </div>
        <el-table border :data="additionParents" height="450px">
          <el-table-column width="80" :label="$t('other.a66')" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-popover placement="top-start" title="" trigger="hover">
                <img :src="scope.row.image" alt="" style="width: 150px; height: 150px" />
                <img slot="reference" :src="scope.row.image" style="width: 30px; height: 30px" />
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column width="200" :label="$t('other.a67')" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.cusCode }}</span>
            </template>
          </el-table-column>
          <el-table-column label="sku" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.skuName }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a2141')">
            <template slot-scope="scope">
              <span>{{ scope.row.component ? $t('other.a251') : $t('other.a252') }}</span>
            </template>
          </el-table-column>
          <el-table-column>
            <template slot-scope="scope">
              <el-input-number size="mini" v-show="isEditGoods" v-model="scope.row.rate" :min="1"></el-input-number>
              <span v-show="!isEditGoods">{{ scope.row.rate }}</span>
            </template>
            <template slot="header">
              <el-tooltip effect="light" :content="$t('other.a2142')" placement="top">
                <span>{{ $t('other.a2143') }}<i class="el-icon-question"
                    style="font-size:22px;margin:0 10px"></i></span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column :label="$t('other.a33')" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-button v-show="isEditGoods" size="mini" type="danger" @click="deletGoods(scope.row, scope.$index)">{{
                $t('other.a312') }}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div v-else>
        <div style="font-size:20px;margin:-20px 0 10px 0;">{{ $t('other.a2516') }}:</div>
        <div style="display: flex; justify-content: space-between">

          <div>
            <el-button size="small" type="primary" @click="isShow = false">{{ $t('other.a605') }}</el-button>
            <span style="margin-left: 15px; font-size: 18px">{{ $t('other.a2144') }}：({{
              multipleSelection.length
            }})</span>
          </div>
          <div style="display: flex">
            <el-select @change="getTableList()" v-model="productType" :placeholder="$t('other.a50')">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <!-- <el-input style="width:350px"  v-model="searchCuscode" placeholder="可搜索仓库编码，商品名，sku" clearable></el-input>
						<el-button type="primary" @click="search()">{{$t('other.a27')}}</el-button> -->
          </div>
        </div>
        <div>
          <el-table :data="tableList" height="400px" style="width: 100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column prop="outTradeNo" :label="$t('other.a66')" width="80">
              <template slot-scope="props">
                <el-popover placement="top-start" title="" trigger="hover">
                  <img :src="props.row.image" alt="" style="width: 150px; height: 150px" />
                  <img slot="reference" :src="props.row.image" style="width: 30px; height: 30px" />
                </el-popover>
              </template>
            </el-table-column>
            <el-table-column :label="$t('other.a67')" :ref="props.row.cusCode" width="180">
              <template slot-scope="props">
                <span>{{ props.row.cusCode }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="itemName" :label="$t('other.a1901')"> </el-table-column>
            <el-table-column prop="skuName" label="SKU"> </el-table-column>
            <el-table-column prop="platform" :label="$t('other.a2143')">
              <template slot-scope="props">
                <el-input-number size="mini" v-model="props.row.rate" :min="1"></el-input-number>
              </template>
            </el-table-column>
          </el-table>
          <div style="width: 100%; display: flex; justify-content: flex-end">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="currentPage4" :page-sizes="[15, 30, 50, 100]" :page-size="dataParams.offset"
              layout="total, sizes, prev, pager, next, jumper" :total="tableCount">
            </el-pagination>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button v-show="!isShow" type="primary" @click="dialogTableVisibleTwo = false">{{ $t('other.a5')
        }}</el-button>
        <el-button v-show="isShow" type="primary" @click="addItem()">{{ $t('other.a279') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :title="$t('other.a1423')" :visible.sync="updatPic" width="30%">
      <div style="text-align: center">
        <el-upload class="avatar-uploader" action="https://erp.shopsbu.com/service/access/upload"
          :show-file-list="false" :headers="token" :on-success="handleAvatarSuccess">
          <img v-if="imageUrl" :src="imageUrl" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          <div slot="tip" class="el-upload__tip">{{ $t('other.a281') }}</div>
        </el-upload>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updatPic = false">{{ $t('other.a106') }}</el-button>
        <el-button type="primary" @click="imgConfirm()">{{ $t('other.a279') }}</el-button>
      </span>
    </el-dialog>
    <!-- 录入产品条形码 -->
    <el-dialog :title="$t('other.a2517')" :visible.sync="productCode" width="30%">
      <el-input v-model="barCode" :placeholder="$t('other.a2518')"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="productCode = false">{{ $t('other.a106') }}</el-button>
        <el-button size="small" type="primary" @click="submitCoding()">{{ $t('other.a274') }}</el-button>
      </span>
    </el-dialog>
    <!-- 选择SPU -->
    <el-dialog title="" :visible.sync="activitySPUShow" width="50%">
      <div class="ipt">
        <div class="label" style="margin-bottom: 10px;">
          请输入需要指定报名的产品SPU:
        </div>
        <el-input type="textarea" :rows="12" v-model="ruleForm.autoActivitySPU" @input="handleInput"
          placeholder="多个SPU换行输入"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="activitySPUShow = false">{{ $t('other.a106') }}</el-button>
        <el-button size="small" type="primary" @click="submitActivity()">{{ $t('other.a274') }}</el-button>
      </span>
    </el-dialog>
    <!-- 选择活动 -->
    <el-dialog title="选择活动" :visible.sync="activityListShow" width="50%">
      <el-select v-model="searchShopId" placeholder="请选择" @change="searchTemu">
        <el-option v-for="item in temuList" :key="item.value" :label="item.label" :value="item.value">
        </el-option>
      </el-select>
      <el-table ref="multipleActivityTable" :data="activityList" style="width: 100%" :span-method="arraySpanMethod"
        :row-class-name="rowcb" :cell-class-name="cellcb" @selection-change="handleSelectionActivityChange"
        height="500px">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="activityThematicName" label="活动主题名称">
          <template slot-scope="scope">{{ scope.row.activityThematicName }}</template>
        </el-table-column>
        <el-table-column prop="activityContent" label="活动时间">
          <template slot-scope="scope" v-if="!scope.row.hidde">
            <span v-if="scope.row.startTime">
              {{ getTiem(scope.row.startTime) }}~{{
                getTiem(scope.row.endTime) }}（{{ scope.row.durationDays
              }}天）
            </span>
            <span v-else>
              优先自动报名进行中活动
            </span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="activityListShow = false">{{ $t('other.a106') }}</el-button>
        <el-button size="small" type="primary" @click="submitActivity()">{{ $t('other.a274') }}</el-button>
      </span>
    </el-dialog>
    <div class="check_Top">
      <div style="margin:15px 0;font-size:18px">{{ $t('other.a2519') }}</div>
      <div class="check_desc">
        <div class="ivmfjn">
          <el-checkbox class="menu" v-model="checked">{{ $t('other.a2520') }}({{ multipleSelection.length
          }})</el-checkbox>
          <el-dropdown class="menu" size="mini" v-if="vipLevel == 0">
            <el-button size="medium" type="primary">
              {{ $t('other.a2521') }} <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="massMoveIn()">{{ $t('other.a2522') }}</el-dropdown-item>
              <el-dropdown-item @click.native="massDeletd()">{{ $t('other.a2523') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-dropdown class="menu" size="mini" v-if="vipLevel == 0">
            <el-button size="medium" type="primary">
              {{ $t('other.a2524') }} <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="insertProduct()"> {{ $t('other.a2525') }}</el-dropdown-item>
              <el-dropdown-item @click.native="kvjhfm()">{{ $t('other.a2526') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <!-- <el-button v-if="!ruleForm.putAway && type == 0 && vipLevel == 0"  type="primary" @click="textFunc()">{{$t('other.a945')}}</el-button> -->
          <el-button v-if="!ruleForm.putAway && type == 0 && vipLevel == 0" type="primary" @click="textFunc()">{{
            $t('other.a2527') }}</el-button>
          <el-button v-if="ruleForm.putAway && type == 0 && vipLevel == 0" type="danger" @click="textFunc()">{{
            $t('other.a2528') }}</el-button>
          <el-button type="primary" @click="publishTikTok()">{{ $t('other.a2529') }}</el-button>

        </div>
        <el-button size="medium" @click="goBack()" type="primary"><i class="iconfont icon-fanhui-"></i>
          {{ $t('other.a605') }}</el-button>
      </div>
    </div>

    <!-- 产品列表 -->
    <div style="margin-top:60px;">
      <div class="header_tip">

      </div>
      <div class="basic_info">
        <div class="title">{{ $t('other.a2530') }}</div>
        <div class="basic_detail">
          <div class="itemskuImg" @click="changePic(ruleForm, 0)">
            <img :src="ruleForm.image ? ruleForm.image : ruleForm.storeItems[0].image" />
          </div>
          <div class="skuDesc">
            {{ $t('other.a179') }}：
            <!-- {{ruleForm.groupName}} -->
            <span v-show="!groupNameChecked">{{ ruleForm.groupName }}</span>
            <el-input type="textarea" style="width:550px" v-show="groupNameChecked" :rows="1"
              :placeholder="$t('other.a2531')" v-model="ruleForm.groupName"> </el-input>
            <i v-show="!groupNameChecked" class="el-icon-edit" @click="groupNameChecked = true"></i>
            <el-button style="margin-left: 15px;" v-show="groupNameChecked" @click="updataItemSku()" size="mini"
              type="primary">{{ $t('other.a145') }}</el-button>
            <el-button style="margin-left: 15px;" v-show="groupNameChecked" @click="groupNameChecked = false"
              size="mini" type="danger">{{ $t('other.a146') }}</el-button>
          </div>
          <div class="skuDesc">
            {{ $t('other.a735') }}：
            <span v-show="!ruleForm.checked">{{ ruleForm.itemSku }}</span>
            <el-input type="textarea" style="width:350px" v-show="ruleForm.checked" :rows="1"
              :placeholder="$t('other.a2531')" v-model="ruleForm.itemSku"> </el-input>
            <i v-show="!ruleForm.checked" class="el-icon-edit" @click="ruleForm.checked = true"></i>
            <el-button style="margin-left: 15px;" v-show="ruleForm.checked" @click="updataItemSku()" size="mini"
              type="primary">{{ $t('other.a145') }}</el-button>
            <el-button style="margin-left: 15px;" v-show="ruleForm.checked" @click="ruleForm.checked = false"
              size="mini" type="danger">{{ $t('other.a146') }}</el-button>
          </div>
          <div class="skuDesc" style="display: flex;">
            TEMU自动报活动:
            <el-switch style="display: block;margin-left: 10px;margin-top: 3px;
                    margin-right: 20px;" v-model="ruleForm.autoActivity" active-color="#13ce66"
              inactive-color="#ff4949" active-text="启动" inactive-text="停止" @change="autoActivityChange"></el-switch>
            <div style="width: 70%;">
              <div style="display: flex; flex: 1;">
                <el-checkbox v-model="ruleForm.useTargetPrice" @change="submitActivity">按目标活动价设置:</el-checkbox>
                <div style=" width: 88%;">
                  <div>
                    <el-button style="margin-left: 20px;" :class="!SPUTextMore ? 'oneMore' : 'oneText'" type="text"
                      @click.stop="openActivitySPU">{{
                        ruleForm.autoActivitySPU ? ruleForm.autoActivitySPU : '指定线上产品SPU' }}</el-button>
                    <el-button style="margin-left: 20px;padding-top: 0px !important;" type="text"
                      @click.stop="SPUTextMore = !SPUTextMore"
                      v-if="!SPUTextMore && ruleForm.autoActivitySPU && ruleForm.autoActivitySPU.length > 30">
                      <span>更多</span>
                    </el-button>
                  </div>
                  <div>
                    <el-button style="margin-left: 20px;" :class="!activityTextMore ? 'oneMore' : 'oneText'" type="text"
                      @click.stop="openActivityList"
                      v-if="ruleForm.activityInfoList && ruleForm.activityInfoList.length > 0">
                      <div v-for="(item, index) in ruleForm.activityInfoList" style="display: inline-block;">
                        {{ item.activityThematicName }}、
                      </div>
                    </el-button>
                    <el-button style="margin-left: 20px;padding-top: 0px !important;" type="text"
                      @click.stop="openActivityList" v-else>
                      <span>选择活动</span>
                    </el-button>
                    <el-button style="margin-left: 20px;padding-top: 0px !important;" type="text"
                      @click.stop="activityTextMore = !activityTextMore"
                      v-if="!activityTextMore && ruleForm.activityInfoList && ruleForm.activityInfoList.length > 3">
                      <span>更多</span>
                    </el-button>
                  </div>
                </div>
              </div>
              <el-checkbox v-model="ruleForm.useSystemSuggest"
                @change="submitActivity">按系统建议价设置:只要不低于目标活动价，则全部活动全部线上产品按系统建议价</el-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class="basic_info">
        <div class="title">
          <span style="margin-right:30px;">{{ $t('other.a2149') }}：{{ ruleForm.storeItems.length }}</span>
          <span class="ogitg"><el-checkbox @change="unbound = false" style="color:#67C23A" v-model="bound">{{
            $t('other.a1436') }}：{{ ruleForm.boundNum }}</el-checkbox></span>
          <span class="ogitg"><el-checkbox @change="bound = false" style="color:#F56C6C" v-model="unbound">{{
            $t('other.a2532') }}：{{ ruleForm.storeItems.length -
                ruleForm.boundNum }}</el-checkbox></span>
        </div>
        <div class="basic_detail">
          <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
            <el-form-item label="" prop="name">
              <el-table ref="multipleTable" :data="storeItmeData" :show-header="false"
                :row-class-name="tableRowClassName" @selection-change="handleSelectionChange" border>
                <el-table-column type="selection" width="55">
                </el-table-column>
                <el-table-column width="100">
                  <template slot-scope="props">
                    <div class="pic_box" @click="changePic(props.row, 1)">
                      <img style="width:100%" :src="props.row.image" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column>
                  <template slot-scope="props">
                    <div style="font-size:14px;">
                      {{ $t('other.a2139') }}：
                      <span v-show="!props.row.skuNameChecked">{{ props.row.skuName ?
                        props.row.skuName
                        : $t('other.a260') }}</span>
                      <el-input v-show="props.row.skuNameChecked" size="mini" style="width: 200px;;"
                        v-model="props.row.skuName" :rows="1" type="textarea" autosize="autosize">
                      </el-input>
                      <div style="margin:5px 0" v-show="props.row.skuNameChecked">
                        <el-button v-show="props.row.skuNameChecked" size="mini" type="primary"
                          @click="saveClick(props.$index, props.row)">{{ $t('other.a274')
                          }}</el-button>
                        <el-button v-show="props.row.skuNameChecked" size="mini" type="danger"
                          @click="saveClick(props.$index, props.row)">{{ $t('other.a106')
                          }}</el-button>
                      </div>
                      <i v-show="!props.row.skuNameChecked" class="el-icon-edit"
                        @click="editClick(props.$index, props.row)"></i>
                    </div>
                    <div style="font-size:14px;">
                      skuName：
                      <span v-show="!props.row.nameChecked">{{ props.row.variationName ?
                        props.row.variationName : $t('other.a260') }}</span>
                      <el-input v-show="props.row.nameChecked" size="mini" style="width: 200px;;"
                        v-model="props.row.variationName" :rows="1" type="textarea" autosize="autosize"> </el-input>
                      <div style="margin:5px 0" v-show="props.row.nameChecked">
                        <el-button v-show="props.row.nameChecked" size="mini" type="primary"
                          @click="saveClickvariationName(props.$index, props.row)">{{
                            $t('other.a274') }}</el-button>
                        <el-button v-show="props.row.nameChecked" size="mini" type="danger"
                          @click="saveClickvariationName(props.$index, props.row)">{{
                            $t('other.a106') }}</el-button>
                      </div>
                      <i v-show="!props.row.nameChecked" class="el-icon-edit"
                        @click="editvaritionNmae(props.$index, props.row)"></i>
                    </div>
                    <div style="font-size:14px;">{{ $t('other.a226') }}{{ props.row.cusCode }}</div>
                    <div style="font-size:14px;" v-if="vipLevel == 1">{{ $t('other.a2533') }}：
                      <span v-show="!props.row.checked02">{{ props.row.supply ? props.row.supply :
                        $t('other.a354') }}</span>
                      <el-input type="textarea" v-show="props.row.checked02" :rows="2" :placeholder="$t('other.a2531')"
                        v-model="props.row.supply"> </el-input>
                      <i class="el-icon-edit-outline" v-show="!props.row.checked02"
                        @click="props.row.checked02 = true">{{
                          $t('other.a2534') }}</i>
                      <span class="lknf" v-show="props.row.checked02" @click="updataCostAndSupply(props.row, 1)">{{
                        $t('other.a274') }}</span>
                      <span class="lknf" v-show="props.row.checked02" @click="props.row.checked02 = false">{{
                        $t('other.a106') }}</span>

                    </div>
                    <div style="font-size:14px;" v-if="vipLevel == 0">
                      {{ $t('other.a1166') }}：{{ props.row.storeId }}</div>
                    <div style="font-size:14px;" v-if="vipLevel == 0">
                      {{ $t('other.a799') }}：{{ props.row.userId }}</div>
                    <div style="font-size:14px;" v-if="vipLevel == 0">{{ $t('other.a2537') }}
                      <i class="el-icon-goods" :title="$t('other.a2535')" @click="getSkuPurchase(props.row)"
                        style="color:#66b1ff;cursor: pointer;"></i>：

                      <span v-show="!props.row.costChecked">{{ props.row.cost }}</span>
                      <el-input v-show="props.row.costChecked" size="mini" style="width: 200px;;"
                        v-model="props.row.cost" :rows="1" type="textarea" autosize="autosize">
                      </el-input>
                      <div style="margin:5px 0" v-show="props.row.costChecked">
                        <el-button v-show="props.row.costChecked" size="mini" type="primary"
                          @click="saveCost(props.$index, props.row)">{{ $t('other.a274')
                          }}</el-button>
                        <el-button v-show="props.row.costChecked" size="mini" type="danger"
                          @click="saveCost(props.$index, props.row)">{{ $t('other.a106')
                          }}</el-button>
                      </div>
                      <i v-show="!props.row.costChecked" class="el-icon-edit"
                        @click="editcost(props.$index, props.row)"></i>
                    </div>

                    <div style="font-size:14px;" v-if="vipLevel == 0">目标活动价：

                      <span v-show="!props.row.defaultActivityPriceChecked">{{
                        props.row.defaultActivityPrice }}</span>
                      <el-input v-show="props.row.defaultActivityPriceChecked" size="mini" style="width: 200px;;"
                        v-model="props.row.defaultActivityPrice" :rows="1" type="textarea" autosize="autosize">
                      </el-input>
                      <div style="margin:5px 0" v-show="props.row.defaultActivityPriceChecked">
                        <el-button v-show="props.row.defaultActivityPriceChecked" size="mini" type="primary"
                          @click="saveDefaultActivityPrice(props.$index, props.row)">{{
                            $t('other.a274')
                          }}</el-button>
                        <el-button v-show="props.row.defaultActivityPriceChecked" size="mini" type="danger"
                          @click="saveDefaultActivityPrice(props.$index, props.row)">{{
                            $t('other.a106')
                          }}</el-button>
                      </div>
                      <i v-show="!props.row.defaultActivityPriceChecked" class="el-icon-edit"
                        @click="editDefaultActivityPrice(props.$index, props.row)"></i>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column>
                  <template slot-scope="props">

                    <div v-if="vipLevel == 0">
                      {{ $t('other.a2538') }}
                      <el-tooltip class="item" effect="dark" :content="$t('other.a2536')" placement="top-start">
                        <i class="el-icon-question oook"></i>:
                      </el-tooltip>
                      ：{{ props.row.auditedStock }}
                    </div>
                    <div v-if="vipLevel == 0">
                      {{ $t('other.a2539') }}
                      <el-tooltip class="item" effect="dark" :content="$t('other.a2542')" placement="top-start">
                        <i class="el-icon-question oook"></i>:
                      </el-tooltip>
                      ：
                      {{ props.row.unShipped - props.row.assibleUnshiped }}({{ $t('other.a251') }}) +
                      {{ props.row.assibleUnshiped }}({{ $t('other.a252') }})
                    </div>
                    <div v-if="vipLevel == 0 && (type == 0 || type == 1)">
                      {{ $t('other.a1037') }}
                      <el-tooltip class="item" effect="dark" :content="$t('other.a1122')" placement="top-start">
                        <i class="el-icon-question oook"></i>:
                      </el-tooltip>
                      ：{{ props.row.stock }}
                    </div>
                    <div style="display: flex" v-if="vipLevel == 0 && (type == 0 || type == 1)">
                      {{ $t('other.a2540') }}
                      <el-tooltip class="item" effect="dark" :content="$t('other.a2541')" placement="top-start">
                        <i class="el-icon-question oook"></i>:
                      </el-tooltip>
                      ：
                      <span v-show="!props.row.checked_one">{{ props.row.reservedStockTotal }}</span>
                      <span v-show="props.row.checked_one"><el-input style="width: 60px;padding:0 5px" size="mini"
                          v-model="props.row.reservedStock" /></span>
                      <span v-show="props.row.checked_one"><el-input style="width: 50px;padding:0 5px" disabled
                          size="mini" v-model="props.row.reservedStockCopy" /></span>
                      <i v-show="!props.row.checked_one" class="el-icon-edit"
                        @click="editResverStock(props.$index, props.row)"></i>
                      <div v-show="props.row.checked_one">
                        <el-button style="margin-left: 15px;" v-show="props.row.checked_one"
                          @click="changeStock(props.$index, props.row)" size="mini" type="primary">{{ $t('other.a145')
                          }}</el-button>
                        <el-button style="margin-left: 15px;" v-show="props.row.checked_one"
                          @click="cancelChangeStock(props.$index, props.row)" size="mini" type="danger">{{
                            $t('other.a146') }}</el-button>
                      </div>
                      <el-switch v-show="!props.row.checked_one" style="display: inline-block;margin-left:15px"
                        v-model="props.row.autoReserved" @change="changeLockStock(props.row)" active-color="#13ce66"
                        inactive-color="#ff4949" :active-text="$t('other.a2543')" :inactive-text="$t('other.a2544')">
                        >
                      </el-switch>
                    </div>
                    <div style="font-size:14px;" v-if="vipLevel == 1">
                      {{ $t('other.a1166') }}：{{ props.row.storeId }}</div>
                    <div style="font-size:14px;" v-if="vipLevel == 1">
                      {{ $t('other.a2545') }}：{{ props.row.userName }}</div>
                    <div>
                      {{ $t('other.a1171') }}
                      <el-tooltip class="item" effect="dark" :content="$t('other.a1123')" placement="top-start">
                        <i class="el-icon-question oook"></i>:
                      </el-tooltip>
                      ：{{ props.row.storeNum }}
                    </div>
                    <div style="font-size:14px;" v-if="vipLevel == 1">{{ $t('other.a2137') }}：
                      <span v-show="!props.row.checked">{{ props.row.cost }}</span>
                      <el-input style="width:100px" size="mini" v-show="props.row.checked" v-model="props.row.cost"
                        placeholder=""></el-input>
                      <i class="el-icon-edit-outline" v-show="!props.row.checked" @click="props.row.checked = true">{{
                        $t('other.a2227') }}</i>
                      <span class="lknf" v-show="props.row.checked" @click="updataCostAndSupply(props.row, 0)">{{
                        $t('other.a274') }}</span>
                      <span class="lknf" v-show="props.row.checked" @click="props.row.checked = false">{{
                        $t('other.a106') }}</span>
                    </div>
                    <div style="display:flex" v-if="vipLevel == 0 && (type == 0 || type == 1)">
                      {{ $t('other.a2546') }}
                      <el-tooltip class="item" effect="dark" :content="$t('other.a2547')" placement="top-start">
                        <i class="el-icon-question oook"></i>:
                      </el-tooltip>
                      ：
                      <el-switch style="display: block" v-model="props.row.synchrony" active-color="#13ce66"
                        inactive-color="#ff4949" @change="updateShopeeItem(props.row)"
                        :active-text="$t('userStoreItems').on" :inactive-text="$t('userStoreItems').off">
                        >
                      </el-switch>
                    </div>

                  </template>
                </el-table-column>
                <el-table-column>
                  <template slot-scope="props">
                    <div v-if="type == 1" style="display:flex">
                      <span>{{ $t('other.a2548') }}：</span>
                      <el-switch style="display: block" v-model="props.row.independent" active-color="#13ce66"
                        inactive-color="#ff4949" @change="setIndependent(props.row)" :active-text="$t('other.a191')"
                        :inactive-text="$t('other.a192')">
                        >
                      </el-switch>
                    </div>
                    <div style="display:flex">
                      <span>{{ $t('other.a784') }}/{{ $t('other.a785') }}：</span>
                      <el-switch style="display: block" v-model="props.row.sensitive" active-color="#13ce66"
                        inactive-color="#ff4949" @change="updataSensitiveGoods(props.row)"
                        :active-text="$t('other.a191')" :inactive-text="$t('other.a192')">
                        >
                      </el-switch>
                    </div>
                    <div v-if="type == 1" v-show="props.row.independent">
                      {{ $t('other.a2549') }}：{{ props.row.separateNum }}</div>
                    <div>{{ $t('other.a2153') }}：{{ props.row.packageLength }} x {{
                      props.row.packageWidth }}
                      x {{ props.row.packageHeight }} cm</div>
                    <div>{{ $t('other.a1516') }}：{{ props.row.weight }} kg</div>
                    <div>{{ $t('other.a1169') }}：{{ props.row.address ? props.row.address :
                      $t('other.a354') }}</div>
                    <div>{{ $t('other.a2550') }}：
                      {{ props.row.encoding ? props.row.encoding : $t('other.a354') }}
                      <i class="el-icon-edit-outline" @click="productCode = true, itemCoding = props.row">{{
                        $t('other.a2551')
                      }}</i>
                    </div>
                    <div v-if="showDistributionPrice">
                      {{ $t('other.a2552') }}￥：
                      <el-input style="width:120px" size="mini" v-model="props.row.price"
                        :placeholder="$t('other.a2553')"></el-input>
                    </div>
                    <div v-if="!showDistributionPrice">
                      {{ $t('other.a2552') }}￥：
                      {{ getVipPirice(props.row) }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-if="vipLevel == 0">
                  <template slot-scope="props">

                    <div class="btn" v-if="type == 0"><el-button style="min-width:150px" size="mini" type="primary"
                        @click="updateComponent(props.row, props.$index)">{{
                          $t('other.a2554') }}</el-button>
                    </div>
                    <div class="btn" v-if="type == 2"><el-button style="min-width:150px" size="mini" type="primary"
                        @click="massMoveInSingle(props.row, props.$index)">{{
                          $t('other.a2555') }}</el-button>
                    </div>
                    <div class="btn" v-if="type == 1"><el-button style="min-width:150px" size="mini" type="primary"
                        @click="updateComponent(props.row, props.$index)">{{
                          $t('other.a2556') }}</el-button>
                    </div>
                    <div class="btn" v-if="type == 1 || type == 0"><el-button style="min-width:150px" size="mini"
                        type="primary" @click="bindItem(props.row)">{{ $t('other.a2429')
                        }}（x{{ props.row.itemNum }}）</el-button>
                    </div>
                    <div class="btn" v-if="type == 1"><el-button style="min-width:150px" size="mini" type="primary"
                        @click="configPackage(props.row)">{{ $t('other.a2557') }}（X
                        {{ props.row.children.length }}）</el-button></div>
                    <div class="btn"><el-button style="min-width:150px" size="mini" type="primary"
                        @click="viewstoreoperaterecord(props.row)">{{ $t('other.a2558')
                        }}</el-button>
                    </div>
                    <div class="btn"><el-button style="min-width:150px" size="mini" type="primary"
                        @click="deleStoreItem(props.row, props.$index)">{{ $t('other.a312')
                        }}</el-button>
                    </div>
                    <div class="kvhkfn" v-if="type == 0 && props.row.parents" @click="viewMore(props.row)">
                      {{ $t('other.a2560') }}（x{{ props.row.parents.length }}）</div>
                    <div class="kvhkfn" v-if="type == 0 && props.row.parents && props.row.putAway"
                      @click="viewAgent(props.row)">
                      {{ $t('other.a2559') }}（x{{ props.row.parents.length }}）</div>
                    <div class="kvhkfn" v-if="type !== 2 && props.row.additions" @click="viewMoreCopy(props.row)">
                      {{ $t('other.a2561') }}（x{{ props.row.additions.length }}）</div>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import utils from '../../../utils/utils'
import api from '../../../api/api'
import userStoreItemsApi from '../../../api/moudles/userStoreItems'
import dialogPlugin from '../component/diaload'
import QrcodeDialog from '../../../components/dialog/qrcodeDialog.vue'
import jsonp from '../../../api/jsonp';
import mygoods from '../../../api/moudles/mygoods';
import neworderApi from '../../../api/moudles/newOrders'
import distributionApi from '../../../api/moudles/distribution'
import md5 from 'js-md5'
import userStoreItems from '../../../api/moudles/userStoreItems';
import { resolve } from 'path';
import { chownSync } from 'fs';
import gallery from '../../../api/moudles/gallery.js'
export default {
  data() {
    return {
      stores: JSON.parse(localStorage.getItem('userInfo')).stores,
      shopIdInfo: JSON.parse(localStorage.getItem('shopIdInfo')),
      storesOptions: [],
      productCode: false,
      showErrorDeleteItem: false,
      agentDialog: false,
      listErrorOptions: [],
      multipleSelection: [],
      itemCoding: null,
      warehouseId: null,
      isComponent: null,
      openDiaconfigPackage: false,
      purchaseHistoryDia: false,
      onlineItems: {},
      tableList: [],
      additionItem: null,
      tableCount: 0,
      type: null,
      barCode: null,
      productType: true,
      isShow: false,
      isEditGoods: false,
      dataParams: {
        addition: false,
        component: true,
        cusCode: null,
        offset: 15,
        page: 0,
        sellerId: null,
        storeId: null,
        userId: JSON.parse(localStorage.getItem('userInfo')).userId
      },
      offset: 15,
      page: 0,
      massPrice: null,
      dialogTableVisibleTwo: false,
      showDistributionPrice: false,
      showProduct: false,
      currentPage4: 1,
      packageInfo: {},
      additionParents: [],
      flag: false,
      agentList: [],
      textDest: null,
      disPrice: false,
      openDialog: false,
      imageUrl: '',
      handleParam: null,
      purchaseList: [],
      costDia: false,
      packageList: [],
      options: [
        {
          label: this.$t('other.a1341'),
          value: true,
        },
        {
          label: this.$t('other.a1342'),
          value: false,
        },
      ],
      changePicObj: {},
      dataParams: {
        component: true,
        cusCode: "",
        offset: 50,
        page: 0,
        sellerId: JSON.parse(localStorage.getItem('userInfo')).userId,
        storeId: null,
        userId: JSON.parse(localStorage.getItem('userInfo')).userId,
      },
      ruleForm: {
        groupName: '',
        categoryId: null,
        itemSku: '',
        storeItems: []
      },
      token: {
        token: JSON.parse(localStorage.getItem('userInfo')).token
      },
      multipleSelection: [],
      checked: false,
      instockdia: false,
      maincusCode: null,
      vipLevel: JSON.parse(localStorage.getItem('userInfo')).vipLevel,
      updatPic: false,
      bound: false,
      unbound: false,
      groupNameChecked: false,
      activitySPUShow: false,
      activityListShow: false,
      autoActivitySPU: '',
      activityList: [],
      multipleActivitySelection: [],
      temuList: [],
      searchShopId: '',
      SPUTextMore: false,
      activityTextMore: false,
    }
  },

  components: {
    QrcodeDialog,
    dialogPlugin

  },

  computed: {
    ...mapState({
      userName: (state) => state.shopaccess.userInfo.userName,
      userId: (state) => state.shopaccess.userInfo.userId,
      isSuper: (state) => state.shopaccess.userInfo.isSuper,
      distributorLevel: (state) => state.shopaccess.userInfo.distributorLevel,

    }),

    storeItmeData() {
      let list = this.ruleForm.storeItems
      let list2 = []
      if (this.bound) {
        list2 = this.ruleForm.storeItems.filter(p => {
          if (p.itemNum > 0) {
            return p
          }
        })
      } else if (this.unbound) {
        list2 = this.ruleForm.storeItems.filter(p => {
          if (p.itemNum == 0) {
            return p
          }

        })
      } else {
        list2 = list
      }

      console.log('852983', list2)
      return list2

    }

  },

  watch: {
    checked() {
      if (this.checked) {
        this.ruleForm.storeItems.forEach(p => {
          this.$refs.multipleTable.toggleRowSelection(p)
        })
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    productCode() {
      if (!this.productCode) {
        this.barCode = null
      }
    },
    updatPic() {
      if (!this.updatPic) {
        this.imageUrl = ''
      }
    },
    flag() {
      if (this.flag) {
        console.log('11111111111111')
      } else {
        console.log('222222222')
      }
    },

  },


  created() {
    this.init()
    if (localStorage.getItem('userInfo')) {
      let data = JSON.parse(localStorage.getItem('userInfo')).temuAuth
      this.temuList = data.map((item) => {
        return {
          label: item.shopName,
          value: item.shopId,
        }
      })
      if (this.temuList.length > 0) {
        this.searchShopId = this.temuList[0].value
      }

    }
  },
  destroyed() {
    // utils.cleanStorageData()
  },
  methods: {
    ...mapActions('userStoreItems', [
      'getInstockoperaterecore',
      'deleStoreItems',
      'sellerUpdateStoreItemDetail',//更新采购价
      'sellerUpdateStoreItem',//更新产品基本信息
      'updateGroup'
    ]),


    getTiem(time) {
      return utils.renderTime(time)
    },
    getVipPirice(item) {
      let price = null
      if (this.isSuper) {
        price = item.children && item.children.length > 0 ? (item.children[0].price) : 0
      } else {
        if (this.distributorLevel == 0) {
          price = item.children && item.children.length > 0 ? (item.children[0].vipPrice ? item.children[0].vipPrice : item.children[0].price) : 0
        } else if (this.distributorLevel == 1) {
          price = item.children && item.children.length > 0 ? (item.children[0].superVipPrice ? item.children[0].superVipPrice : item.children[0].price) : 0
        }
      }
      return price
    },

    publishTikTok() {
      let that = this
      let list = []

      this.ruleForm.storeItems.forEach(p => {
        list.push(that.getUrlBycusCode(p))
      })

      Promise.all(list).then((res) => {
        let onlineList = []
        let arr1 = []
        res.forEach(p => {
          if (Array.isArray(p)) {
            p.forEach(i => {
              let shopIdInfo = this.shopIdInfo.find(item => item.shopId == i.shopId)
              if (arr1.indexOf(i.itemId) == -1 && i.itemKey.indexOf('SHOPEE') > -1) {
                arr1.push(i.itemId)
                onlineList.push({
                  itemId: i.itemId,
                  shopId: i.shopId,
                  country: shopIdInfo.country
                })
              }
            })
          }
        })
        utils.updateInfoByCache({
          cacheKey: 'onlineOptions',
          userId: this.userId,
          cacheData: JSON.stringify(onlineList)
        })




        console.log('onlineList', onlineList);

      })


      let router = this.$router.resolve({
        name: "publishTikTok",
        query: {
          id: this.ruleForm.productId,
          groupId: this.$route.query.groupId,
          from: 'single'
        }
      })
      window.open(router.href, '_blank');

    },

    //获取指次采购sku的数据

    getSkuPurchase(item) {
      console.log('99')

      api
        .getSkusPurchaseInfo(item)
        .then(res => {
          if (res.code === 200) {
            console.log('desc', res.data)

            res.data.forEach(p => {
              p.createTime = utils.getCurrnetTime(p.createTime)
            })
            this.purchaseList = res.data
            this.purchaseHistoryDia = true
          } else {
            this.$message.warning(res.msg)
          }
        })
    },



    updataSensitiveGoods(item) {
      console.log('852963', item)
      item.sensitive = !item.sensitive
      let params = JSON.parse(JSON.stringify(item))
      let falg = item.sensitive
      let text = null
      if (!falg) {
        text = this.$t('other.a2562')
      } else {
        text = this.$t('other.a2563')
      }
      this.$confirm(text, this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
      }).then(() => {
        params.sensitive = !falg
        userStoreItemsApi
          .updateSensitive(params)
          .then(res => {
            if (res.code === 200) {
              console.log('desc', res.data)
              item.sensitive = !falg
              this.$message.success(this.$t('other.a741'))
            } else {
              this.$message.warning(res.msg)
            }
          })
      })
        .catch(() => { })

    },

    //test

    textFunc() {
      let that = this
      let list = []
      this.ruleForm.storeItems.forEach(p => {
        console.log(p)
        list.push(that.getUrlBycusCode(p))
      })
      console.log(list)
      Promise.all(list).then((res) => {
        console.log('res', res)
        let onlineLink = res
        let arr = []
        let noBindLink = onlineLink.every(item => {
          return item[0].shopId == null
        })

        let noStatus = onlineLink.some(item => {
          return item[0].itemKey != null && item[0].itemKey.includes('TEMU')
        })
        console.log(noStatus)
        console.log(onlineLink)
        console.log(noBindLink)
        console.log("===1====")

        // return
        if (noBindLink || noStatus) {
          let variations = this.ruleForm.storeItems.map((i, index) => {
            return {
              stock: i.stock,
              shopIdInfo: null,
              price: i.price.toFixed(2),
              image: i.image,
              imageId: i.imageId,
              variationSku: i.skuName,
              name: i.variationName,
              country: this.ruleForm.country,
              priceList: 0,
              minRmb: 0,
              tierIndex: [index],
              cusCode: i.cusCode,
              packageHeight: i.packageHeight,
              packageLength: i.packageLength,
              packageWidth: i.packageWidth,
              cost: i.cost,
              costCopy: null,
              costDesc: this.$t('other.a2495') + i.cost,
              weight: i.weight,
              fixGrossProfitRate: 0,
              wholesalePrice: i.wholesalePrice,
              proportion: i.proportion == 0.3 ? true : false
            }
          })
          console.log(variations)
          localStorage.setItem('onlineItem', JSON.stringify({
            arr: [],
            variations: variations,
          }))

          this.$router.push({
            path: '/editor',
            query: {
              groupId: this.$route.query.groupId,
              type: this.$route.query.type,
              storeId: this.ruleForm.storeId
            }
          })
          return
        }
        onlineLink.forEach(k => {
          k.forEach(p => {
            console.log(this.shopIdInfo)
            let shopIdInfo = this.shopIdInfo.find(item => item.shopId == p.shopId)
            p.shopIdInfo = shopIdInfo ? shopIdInfo : null
            p.country = shopIdInfo ? shopIdInfo.country : this.ruleForm.country
            p.rmbList = []
            console.log(shopIdInfo)
            if (shopIdInfo) {
              p.rmbList = k.map(item => utils.interestRateConversion(shopIdInfo.country, item.price))
              if (p.rmbList) {
                p.minRmb = Math.min(...p.rmbList)
              } else {
                p.minRmb = this.$t("other.a354")
              }
            }
            p.priceList = k.map(item => item.price)
            console.log(p.country)
            if (p.country) {
              arr.push(p)
            }
          })
        })
        console.log('----')
        console.log(onlineLink)
        console.log(this.ruleForm.storeItem)
        console.log(arr)

        let variations = this.ruleForm.storeItems.map((i, index) => {
          let ttp = arr.find(item => item.cusCode == i.cusCode)
          return {
            stock: i.stock > 0 ? i.stock : 0,
            shopIdInfo: ttp ? ttp.shopIdInfo : null,
            price: i.price.toFixed(2),
            image: ttp ? ttp.image : null,
            imageId: ttp ? ttp.imageId : null,
            variationSku: i.variationName,
            name: i.variationName,
            country: ttp && ttp.shopIdInfo ? ttp.shopIdInfo.country : ttp.country,
            priceList: ttp ? Math.min(...ttp.priceList) : 0,
            minRmb: ttp ? ttp.minRmb : 0,
            tierIndex: [index],
            cusCode: i.cusCode,
            packageHeight: i.packageHeight,
            packageLength: i.packageLength,
            packageWidth: i.packageWidth,
            cost: i.cost,
            costCopy: null,
            costDesc: this.$t('other.a2495') + i.cost,
            weight: i.weight,
            fixGrossProfitRate: 0,
            wholesalePrice: i.wholesalePrice,
            proportion: i.proportion == 0.3 ? true : false

          }
        })
        console.log(arr)
        localStorage.setItem('onlineItem', JSON.stringify({
          arr: arr,
          variations: variations,
        }))

        this.$router.push({
          path: '/stockProduct/template',
          query: {
            groupId: this.$route.query.groupId,
            type: this.$route.query.type,
            storeId: this.ruleForm.storeId

          }
        })



      })

    },
    /* 获取产品绑定的线上链接
    *参数：产品的cusCode
    *返回值： array 
    */
    getUrlBycusCode(params) {
      return new Promise((resolve, reject) => {
        mygoods
          .getBindItems({ cusCode: params.cusCode })
          .then(res => {
            if (res.code === 200) {
              let list = null
              if (!res.data.length) {
                list = [{
                  cusCode: params.cusCode,
                  id: null,
                  image: params.image,
                  itemId: null,
                  itemKey: null,
                  itemName: null,
                  itemSku: null,
                  mainImage: params.image,
                  msg: null,
                  normal: true,
                  packageHeight: 0,
                  packageLength: 0,
                  packageWidth: 0,
                  price: 0,
                  reservedStock: 0,
                  shopId: null,
                  variationId: null,
                  variationName: null,
                  variationSku: null,
                  weight: 0
                }]
                // console.log(this.getProductByGroupId(params))
                // list=this.getProductByGroupId(params)
              } else {
                list = res.data
              }
              resolve(list)
            } else {
              reject(null)
            }
          })
      })
    },
    getProductByGroupId(params) {
      console.log(params)
      return new Promise((resolve, reject) => {
        mygoods
          .getProductByGroupId({ groupId: params.groupId })
          .then(res => {
            if (res.code === 200) {
              let list = null
              if (!res.data.length) {
                list = [{
                  cusCode: params.cusCode,
                  id: null,
                  image: params.image,
                  itemId: null,
                  itemKey: null,
                  itemName: null,
                  itemSku: null,
                  mainImage: params.image,
                  msg: null,
                  normal: true,
                  packageHeight: 0,
                  packageLength: 0,
                  packageWidth: 0,
                  price: 0,
                  reservedStock: 0,
                  shopId: null,
                  variationId: null,
                  variationName: null,
                  variationSku: null,
                  weight: 0
                }]
              } else {
                list = res.data
              }
              resolve(list)
            } else {
              reject(null)
            }
          })
      })
    },

    ongkon() {
      let list = this.ruleForm.storeItems.map(p => {
        return p.cusCode
      })
      let calcNum = 0
      let arrList = []
      let arr = []
      let listTwo = []
      list.forEach(p => {
        mygoods
          .getBindItems({
            cusCode: p
          }).then(res => {
            if (res.code == 200) {
              // this.showLoading('正在获取分销数据，稍等。。。')

              if (!res.data.length) {
                let storeItem = this.ruleForm.storeItems.find(i => i.cusCode == p)
                listTwo = [{
                  cusCode: p,
                  id: null,
                  image: storeItem.image,
                  itemId: null,
                  itemKey: null,
                  itemName: null,
                  itemSku: null,
                  mainImage: storeItem.image,
                  msg: null,
                  normal: true,
                  packageHeight: 0,
                  packageLength: 0,
                  packageWidth: 0,
                  price: 0,
                  reservedStock: 0,
                  shopId: null,
                  variationId: null,
                  variationName: null,
                  variationSku: null,
                  weight: 0
                }]
              } else {
                listTwo = res.data
              }

              listTwo.forEach(p => {
                let shopIdInfo = this.shopIdInfo.find(item => item.shopId == p.shopId)
                p.shopIdInfo = shopIdInfo ? shopIdInfo : null
                p.country = shopIdInfo ? shopIdInfo.country : this.ruleForm.country
                p.rmbList = []
                if (shopIdInfo) {
                  p.rmbList = res.data.map(item => utils.interestRateConversion(shopIdInfo.country, item.price))
                  if (p.rmbList) {
                    p.minRmb = Math.min(...p.rmbList)
                  } else {
                    p.minRmb = this.$t("other.a354")
                  }
                }
                p.priceList = res.data.map(item => item.price)

                if (p.country) {
                  arr.push(p)
                }
              })
              calcNum += 1
              arrList.push(listTwo)
              console.log('arrList', arrList)
              console.log('arr', arr)
              console.log('calcNum', calcNum)


              if (calcNum == list.length) {
                let variations = this.ruleForm.storeItems.map((i, index) => {
                  let ttp = arr.find(item => item.cusCode == i.cusCode)
                  return {
                    stock: i.stock > 0 ? i.stock : 0,
                    shopIdInfo: ttp ? ttp.shopIdInfo : null,
                    price: i.price.toFixed(2),
                    image: ttp ? ttp.image : null,
                    imageId: ttp ? ttp.imageId : null,
                    variationSku: i.skuName,
                    name: i.skuName,
                    country: ttp && ttp.shopIdInfo ? ttp.shopIdInfo.country : ttp.country,
                    priceList: ttp ? Math.min(...ttp.priceList) : 0,
                    minRmb: ttp ? ttp.minRmb : 0,
                    tierIndex: [index],
                    cusCode: i.cusCode,
                    packageHeight: i.packageHeight,
                    packageLength: i.packageLength,
                    packageWidth: i.packageWidth,
                    cost: i.cost,
                    costCopy: null,
                    costDesc: this.$t('other.a2495') + i.cost,
                    weight: i.weight,
                    fixGrossProfitRate: 0,
                    wholesalePrice: i.wholesalePrice,
                    proportion: i.proportion == 0.3 ? true : false

                  }
                })

                console.log('variations', variations)



                localStorage.setItem('onlineItem', JSON.stringify({
                  arr: arr,
                  variations: variations,
                }))

                // if(arr.length == 0  ){
                //     this.$router.push({
                //         path:'/editor',
                //         query:{
                //             groupId:this.$route.query.groupId,
                //             storeId:this.ruleForm.storeId
                //         }
                //     })

                //     return
                // }





                // this.$router.push({
                //     path:'/stockProduct/template',
                //     query:{
                //         groupId:this.$route.query.groupId,
                //         type:this.$route.query.type,
                //         storeId:this.ruleForm.storeId

                //     }
                // })
                console.log('arr', arr)
              }
            }
          })
      })





      // setTimeout(() => {
      //     this.hideLoading()
      //     if(arrList.length == this.ruleForm.storeItems.length){
      //         this.updataDistribute()
      //     }else{
      //         this.$confirm('当前尚有未绑定线上链接的仓库子sku,请确认全部sku绑定好的线上链接后再上架分销！', this.$t("other.a142"), {
      //         confirmButtonText: this.$t("other.a884"),
      //         cancelButtonText: this.$t('other.a146'),
      //         type: 'warning'
      //         }).then(() => {

      //         })

      //     }
      // },2000)

    },

    updataDistribute() {
      console.log(this.ruleForm)
      if (this.ruleForm.storeItems) {
        let list = this.ruleForm.storeItems.map(p => {
          return p.cusCode
        })
        let calcNum = 0

        if (list) {
          let arr = []
          list.forEach(p => {
            mygoods
              .getBindItems({
                cusCode: p
              })
              .then(res => {
                if (res.code === 200) {
                  console.log('线上产品', res.data)
                  if (res.data) {
                    res.data.forEach(p => {
                      let shopIdInfo = this.shopIdInfo.find(item => item.shopId == p.shopId)
                      console.log('shopIdInfo', shopIdInfo)
                      p.shopIdInfo = shopIdInfo
                      p.country = shopIdInfo ? shopIdInfo.country : null
                      p.rmbList = []
                      if (shopIdInfo) {
                        p.rmbList = res.data.map(item => utils.interestRateConversion(shopIdInfo.country, item.price))
                        if (p.rmbList) {
                          p.minRmb = Math.min(...p.rmbList)
                        } else {
                          p.minRmb = this.$t("other.a354")
                        }
                      }
                      p.priceList = res.data.map(item => item.price)

                      if (p.country) {
                        arr.push(p)
                      }
                    })
                    calcNum += 1
                    if (calcNum == list.length) {
                      let variations = this.ruleForm.storeItems.map((i, index) => {
                        let ttp = arr.find(item => item.cusCode == i.cusCode)
                        return {
                          stock: i.stock > 0 ? i.stock : 0,
                          shopIdInfo: ttp ? ttp.shopIdInfo : null,
                          price: i.price.toFixed(2),
                          image: ttp ? ttp.image : null,
                          imageId: ttp ? ttp.imageId : null,
                          variationSku: i.skuName,
                          name: i.skuName,
                          country: ttp ? ttp.shopIdInfo.country : null,
                          priceList: ttp ? Math.min(...ttp.priceList) : 0,
                          minRmb: ttp ? ttp.minRmb : 0,
                          tierIndex: [index],
                          cusCode: i.cusCode,
                          packageHeight: i.packageHeight,
                          packageLength: i.packageLength,
                          packageWidth: i.packageWidth,
                          cost: i.cost,
                          costCopy: null,
                          costDesc: this.$t('other.a2495') + i.cost,
                          weight: i.weight,
                          fixGrossProfitRate: 0,
                          wholesalePrice: i.wholesalePrice,
                          proportion: i.proportion == 0.3 ? true : false

                        }
                      })

                      console.log('variations', variations)



                      localStorage.setItem('onlineItem', JSON.stringify({
                        arr: arr,
                        variations: variations,
                      }))



                      if (arr.length == 0) {
                        this.$router.push({
                          path: '/editor',
                          query: {
                            groupId: this.$route.query.groupId,
                            storeId: this.ruleForm.storeId
                          }
                        })

                        return
                      }





                      this.$router.push({
                        path: '/stockProduct/template',
                        query: {
                          groupId: this.$route.query.groupId,
                          type: this.$route.query.type,
                          storeId: this.ruleForm.storeId

                        }
                      })
                      console.log('arr', arr)
                    }

                  }

                } else {
                  this.$message.warning(res.msg)
                }
              })
          })
        }


        console.log('list', list)

      } else {
        this.$message.warning(this.$t('other.a2895'))
      }
    },

    openUrl(num) {

      console.log(this.ruleForm)
      if (num == 0) {//以自定义分销供货价上价
        this.textDest = this.$t('other.a2564')
        this.disPrice = true
      } else if (num == 1) {
        this.textDest = this.$t('other.a2565')
        this.disPrice = false
      }
      let flags = false
      let obj = this.ruleForm.categoryData
      console.log('jfkf', obj)
      if (obj) {
        for (let i in obj) {
          console.log(obj[i])
          if (!obj[i]) {
            flags = true
          }
        }

      } else {
        flags = true

      }
      if (flags && !this.ruleForm.productId) {
        this.$router.push({
          path: '/editor',
          query: {
            groupId: this.$route.query.groupId,
            storeId: this.ruleForm.storeId
          }
        })

        return
      }

      if (this.ruleForm.productId) {
        this.showDistributionPrice = true
        this.massPrice = this.disPrice ? this.ruleForm.storeItems[0].price : this.ruleForm.fixGrossProfitRate
        return
      }


      this.showDistributionPrice = true
      this.massPrice = this.ruleForm.storeItems[0].price



      console.log(this.ruleForm)


    },

    kvjhfm(item) {
      this.openDialog = true
      this.handleParam = this.ruleForm

    },

    createItemNotProduct(data) {
      console.log(this.type)
      console.log(data)
      console.log('data', data)
      let params = {
        addition: this.type == 2 ? true : false,
        address: null,
        component: this.type == 0 ? true : false,
        cost: 0,
        cusCode: 0,
        encoding: null,
        groupId: this.handleParam ? this.handleParam.groupId : null,
        groupName: this.handleParam ? this.handleParam.groupName : null,
        image: data.imageUrl,
        itemSku: null,
        packageHeight: Number(data.height),
        packageLength: Number(data.long),
        packageWidth: Number(data.width),
        weigth: Number(data.weigth),
        shopId: this.handleParam ? this.handleParam.shopId : null,
        shopee: true,
        skuName: data.name,
        storeId: this.handleParam ? this.handleParam.storeId : null,
        userId: this.userId,
        variationName: data.variationName,
        price: data.price || null,
      }

      console.log('params', params)
      gallery.addStoreItemNotProductUpdateParents(params,data.isUpdateParents)
        .then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('other.a2566'))
            if (res.data.successItem) {
              this.getDataByGroupId()
            }

          } else {
            this.$message.warning(res.msg)
          }
        })
    },


    changerPrice() {
      this.massPrice = Number(this.massPrice)
      let ttp = /^[0-9]+.?[0-9]*$/.test(this.massPrice)

      console.log(ttp, this.massPrice)
      if (!ttp) {
        this.massPrice = null
        this.$message.warning(this.$t('other.a2567'))
        return
      }

      if (this.massPrice < 0) {
        this.$message.warning(this.$t('other.a2567'))
      } else {
        if (this.disPrice) {
          this.ruleForm.storeItems.forEach(p => {
            p.price = this.massPrice
          })
          this.ruleForm.fixGrossProfitRate = null

        } else {
          this.ruleForm.fixGrossProfitRate = this.massPrice
        }
      }

    },


    //异步计算产品的毛利
    getStoreItemPrice() {
      return new Promise((resolve) => {
        let obj = {
          cusCode: null,
          price: null,
        }
        this.ruleForm.storeItems.forEach(p => {
          if (!obj.price) {
            obj.cusCode = p.cusCode
            obj.price = p.price
          }
          if (p.price > obj.price) {
            obj.cusCode = p.cusCode
            obj.price = p.price
          }
        })

        mygoods
          .getBindItems({
            cusCode: obj.cusCode
          })
          .then(res => {
            if (res.code === 200) {
              console.log('desc', res.data)
              let price = []
              if (res.data) {
                res.data.forEach(p => {
                  price.push(p.price)
                })
                let num = Math.min(...price)
                let rate = utils.interestRateConversion('TH', num)
                console.log('num', utils.interestRateConversion('TH', num), num)

                resolve(rate)
              }



            } else {
              this.$message.warning(res.msg)
            }
          })

        console.log('groupidlist', this.ruleForm.storeItems, obj)

      })
    },


    distribution() {
      if (!this.disPrice && this.massPrice < 0.05) {
        console.log(this.massPrice)
        this.$confirm(this.$t('other.a2568'), this.$t("other.a142"), {
          confirmButtonText: this.$t('other.a955'),
          cancelButtonText: this.$t('other.a146'),
          type: 'warning'
        }).then(() => { })

        return



      }
      console.log(this.ruleForm)
      this.showDistributionPrice = false
      this.ruleForm.putAway = false
      let isPrice = false
      this.ruleForm.putAway = true
      this.ruleForm.storeItems.forEach(p => {
        p.putAway = true
        p.price = Number(p.price)
        if (p.price <= 0) {
          isPrice = true
        }
      })
      if (isPrice) {
        this.$message.warning(this.$t('other.a2569'))
        this.showDistributionPrice = false
        this.ruleForm.putAway = false
        return
      }

      this
        .getStoreItemPrice()
        .then(res => {
          console.log('res', res)
          let list = this.ruleForm.storeItems.map(p => {
            return p.price
          })

          let maxPrice = Math.max(...list)
          //线上销售最低的零售价
          let lower = Number(res - maxPrice)
          console.log('list', maxPrice, lower)
          let iinv = lower / maxPrice
          console.log('iinv', iinv)

          //     //如果仓库产品绑定了模版
          // if(this.ruleForm.productId){
          //     this.ruleForm.putAway=true
          //     this.ruleForm.storeItems.forEach(p => {
          //         p.putAway=true
          //     })

          //     console.log('ruleForm',this.ruleForm)
          //     distributionApi
          //     .putAwayToDistribution(this.ruleForm)
          //     .then(res => {
          //     if(res.code === 200 ){
          //     console.log('desc',res.data)
          //     this.$message.success(this.$t('other.a2503'))
          //     this.ruleForm.storeItems.forEach(i => {
          //         i.synchrony=true
          //         this.updataSync(i)
          //     })

          //     this.showDistributionPrice=false
          //     }else{
          //     this.$message.warning(res.msg)
          //     }
          //     })
          //     return 
          // }

          let url = null
          // 判断产品是否有itemId,shopId
          if (!this.ruleForm.productId && this.ruleForm.country) {
            url = utils.getUrlByItemIDandCountry(this.ruleForm.country, this.ruleForm.categoryData.itemId, this.ruleForm.categoryData.shopId)
            let matchId = "itemid=" + this.ruleForm.categoryData.itemId + '&' + "shopid=" + this.ruleForm.categoryData.shopId
            let if_match_ = "55b03-" + md5.hex("55b03" + md5.hex(matchId) + "55b03")
            let host = url.slice(0, url.indexOf("?") + 1)
            console.log('host', host)

            api
              .scrapedProdcutItem({
                ifMatchIn: if_match_,
                origin: host,
                url: url
              })
              .then(res => {
                if (!res.data) {
                  this.$message.warning(this.$t('other.a2570'))
                  this.ruleForm.putAway = false
                  return
                }
                res.item = res.data
                console.log('desc', res)
                let obj = {
                  attributes: [],
                  productShops: [],
                  categoryId: 0,
                  modelId: null,
                  name: null,
                  images: [],
                  status: 'NORMAL',
                  description: null,
                  packageLength: '',
                  packageWidth: '',
                  packageHeight: '',
                  country: 'ROOT',
                  weight: '',
                  price: null,
                  hasVariation: false,
                  variations: [],
                  tiers: [],
                  logistics: [],
                  userId: null
                }

                if (this.ruleForm.storeItems) {
                  obj.packageLength = this.ruleForm.storeItems[0].packageLength
                  obj.packageWidth = this.ruleForm.storeItems[0].packageWidth
                  obj.packageHeight = this.ruleForm.storeItems[0].packageHeight
                  obj.weight = this.ruleForm.storeItems[0].weight
                }

                obj.description = res.item.description
                obj.name = res.item.name
                obj.sourceUrl = host + matchId
                obj.categoryId = res.item.categories[res.item.categories.length - 1].catid
                if (res.item.attributes) {
                  res.item.attributes.forEach((p, index) => {
                    obj.attributes.push({
                      attributeId: p.id,
                      attributeName: p.name,
                      attributeValue: p.value,
                      isMandatory: false
                    })
                  })


                  let obj1 = {};
                  let res1 = [];
                  obj.attributes.forEach(k => {
                    if (!obj1[k.attributeId]) {
                      res1.push(k)
                      obj1[k.attributeId] = true
                    }
                  })

                  obj.attributes = res1


                } else {
                  res.item.attributes = null
                }

                res.item.images.forEach((p, index) => {
                  obj.images.push({
                    image: utils.getImageUrl(this.ruleForm.country, p),
                    positions: index
                  })
                })
                let variations = [];
                res.item.tier_variations.forEach((p, index) => {
                  if (p.images) {

                    p.images = p.images.map(k => {
                      return utils.getImageUrl(this.ruleForm.country, k)
                    })
                  }
                  obj.tiers.push({
                    images: p.images,
                    name: p.name,
                    optionArray: p.options,

                  })
                })


                this.ruleForm.storeItems.forEach((i, index) => {
                  variations.push({
                    stock: i.storeNum > 0 ? i.storeNum : 0,
                    price: i.price,
                    variationSku: i.skuName,
                    name: i.skuName,
                    tierIndex: [index]
                  })
                })
                obj.tiers[0].optionArray = []
                this.ruleForm.storeItems.forEach(p => {
                  obj.tiers[0].optionArray.push(p.skuName)
                })

                obj.variations = variations;
                obj.userId = this.userId
                console.log('obj', obj)

                api
                  .updataProduct(obj)
                  .then(res => {
                    if (res.code === 200) {
                      api
                        .updateProductId({
                          groupId: this.ruleForm.groupId,
                          storeId: this.ruleForm.storeId,
                          productId: res.data.productId,
                          userId: this.userId
                        })
                        .then(res => {
                          if (res.code === 200) {
                            this.$message.success(this.$t('other.a2502'))
                            distributionApi
                              .putAwayToDistribution(this.ruleForm)
                              .then(res => {
                                if (res.code === 200) {
                                  console.log('desc', res.data)
                                  this.$message.success(this.$t('other.a2503'))
                                  this.ruleForm.storeItems.forEach(i => {
                                    i.synchrony = true
                                    this.updataSync(i)
                                  })

                                  this.showDistributionPrice = false
                                } else {
                                  this.$message.warning(res.msg)
                                }
                              })

                          } else {
                            this.$message.warning(res.msg)
                          }
                        })
                    } else {
                      this.$message.warning(res.msg)
                    }
                  })

              })
          } else {
            distributionApi
              .putAwayToDistribution(this.ruleForm)
              .then(res => {
                if (res.code === 200) {
                  console.log('desc', res.data)
                  this.$message.success(this.$t('other.a2503'))
                  this.ruleForm.storeItems.forEach(i => {
                    i.synchrony = true
                    this.updataSync(i)
                  })

                  this.showDistributionPrice = false
                } else {
                  this.$message.warning(res.msg)
                }
              })
          }
        })
    },

    updataSync(ttp) {
      userStoreItemsApi
        .sellerUpdateSynchrony(ttp)
        .then(res => {
          if (res.code === 200) {
            console.log('desc', res.data)
          } else {
            console.log(res.msg)
          }
        })
    },


    imgConfirm() {
      console.log(this.changePicObj)
      if (this.changePicObj.type == 0) {
        userStoreItemsApi
          .updateStoreParentImage({
            imageUrl: this.changePicObj.image,
            key: this.changePicObj.groupId,
            stringkey: 0
          })
          .then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('other.a2571'))
              this.ruleForm.image = this.changePicObj.image
            } else {
              this.$message.warning(res.msg)
            }
          })
      }

      if (this.changePicObj.type == 1) {




        userStoreItemsApi
          .updateStoreItemImage({
            imageUrl: this.changePicObj.image,
            key: this.changePicObj.cusCode,
            stringkey: 1
          })
          .then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('other.a2571'))
              this.ruleForm.storeItems.forEach(p => {
                if (p.cusCode == this.changePicObj.cusCode) {
                  p.image = this.changePicObj.image
                }
              })
            } else {
              this.$message.warning(res.msg)
            }
          })
      }
    },

    changePic(item, index) {
      this.updatPic = true
      this.changePicObj = JSON.parse(JSON.stringify(item))
      this.changePicObj.type = index

      console.log('changePicObj', this.changePicObj)


    },

    updataIsDistribution(item) {
      item.putAway = !item.putAway
      let obj = JSON.parse(JSON.stringify(item))
      if (item.putAway) {
        obj.putAway = false
        distributionApi
          .undershelfChildrenSku(obj)
          .then(res => {
            if (res.code === 200) {
              this.$message.success(this.$t('other.a2572') + obj.skuName)
              item.putAway = false
            } else {
              this.$message.warning(res.msg)
            }
          })
      } else {
        obj.putAway = true
        distributionApi
          .shelfChildrenSku(obj)
          .then(res => {
            if (res.code === 200) {
              this.$message.success('sku:' + obj.skuName + this.$t('other.a2573'))
              item.putAway = true
            } else {
              this.$message.warning(res.msg)
            }
          })
      }
      console.log(item)
    },

    setIndependent(item) {
      userStoreItemsApi
        .updateIndependent({
          independent: item.independent,
          cusCode: item.cusCode,
          userId: this.userId,
          storeId: item.storeId,
        })
        .then(res => {
          if (res.code === 200) {
            if (item.independent) {
              this.$message.success(this.$t('other.a2574'))
            } else {
              this.$message.warning(this.$t('other.a2575'))
            }

          }
        })



    },

    viewAgent(item) {
      console.log('item', item)
      if (item.parents) {
        this.agentList = item.parents.map(p => {
          return {
            userId: p.userId,
            userName: p.userName,
            cusCode: p.cusCode
          }
        })
        this.agentDialog = true
        console.log('list', list)

      }
    },

    viewMore(item) {
      console.log(item)
      let list = item.parents.map(p => {
        return p.cusCode
      })
      let str = list.join(',')
      console.log(str)
      this.$confirm(this.$t('other.a2576') + str, this.$t("other.a142"), {
        confirmButtonText: this.$t("other.a884"),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
      }).then(() => { })

    },
    viewMoreCopy(item) {
      console.log(item)
      let list = item.additions.map(p => {
        return p.cusCode
      })
      let str = list.join(',')
      console.log(str)
      this.$confirm(this.$t('other.a2576') + str, this.$t("other.a142"), {
        confirmButtonText: this.$t("other.a884"),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
      }).then(() => { })

    },

    configPackage(item) {
      console.log(item)
      this.openDiaconfigPackage = true
      this.packageList = item.children
      this.packageInfo.storeId = item.storeId
      this.packageInfo.cusCode = item.cusCode

    },

    cancelChangeStock(index, row) {
      row.checked_one = false
      this.$set(this.ruleForm.storeItems, index, row)
    },

    updataItemSku() {
      this.ruleForm.itemSku = this.ruleForm.itemSku.trim()
      if (this.ruleForm.itemSku.length > 35) {
        this.$message.warning(this.$t('other.a2577'))
        return
      }

      this.updateGroup(this.ruleForm)
      this.ruleForm.checked = false
      this.groupNameChecked = false
    },

    changeStock(index, row) {
      console.log(index, row)
      let patten = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g

      if (!patten.test(row.reservedStock)) {
        this.$message.warning(this.$t('other.a2578'))
        row.reservedStock = 0
        return
      }

      console.log(row.reservedStock)
      row.checked_one = false
      this.$set(this.ruleForm.storeItems, index, row)

      let params = {
        cusCode: row.cusCode,
        storeNum: row.reservedStock,

      }
      api
        .updateReservedStock(params)
        .then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('other.a665'))
            this.getDataByGroupId()
          } else {
            this.$message.warning(res.msg)
          }
        })


    },


    insertProduct() {
      this.$router.push({
        path: '/onlineGoods',
        query: {
          storeId: this.ruleForm.storeItems[0].storeId,
          component: this.ruleForm.storeItems[0].component,
          groupId: this.ruleForm.groupId
        }
      })
    },

    editResverStock(index, row) {
      row.checked_one = true
      this.$set(this.ruleForm.storeItems, index, row)
    },
    saveClick(index, row) {
      row.skuName = row.skuName.trim()
      if (row.skuName.length > 32) {
        this.$message.warning(this.$t('other.a2579'))
        return
      }
      console.log(row.skuName.length)
      this.sellerUpdateStoreItem(row).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('other.a2580'))
        } else {
          this.$message.warning(res.msg)
        }
      })
      row.skuNameChecked = false
      this.$set(this.ruleForm.storeItems, index, row)
    },
    saveItems() {
      this.isEditGoods = !this.isEditGoods;
      let arr = this.additionParents.map((p) => {
        return {
          childrenId: this.additionItem.cusCode,
          parentId: p.cusCode,
          rate: p.rate,
        };
      });
      let params = {
        binds: arr,
        parentId: this.additionItem.cusCode,
        userId: this.userId,
      };

      console.log(params);
      // this.updateBindStoreItem(params)
      userStoreItemsApi
        .updateBindStoreItemAddition(params)
        .then(res => {
          if (res.code === 200) {
            this.$message.success(this.$t('other.a2159'))
            this.getDataList.page = 0
            this.getStoreItemAndGroup()
            this.isEditGoods = false

          }
        })
    },

    getTableList() {
      this.dataParams.storeId = this.warehouseId
      this.dataParams.component = this.productType
      userStoreItemsApi.
        getStoreItemBystore(this.dataParams).then((res) => {
          if (res.code === 200) {
            console.log("套餐或单品", res.data);
            this.tableList = res.data.items;
            this.tableCount = res.data.count;
          }
        });
    },

    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.dataParams.offset = parseInt(`${val}`);
      this.handleCurrentChange();
    },

    //显示当前第几页
    handleCurrentChange(val) {

      this.dataParams.page = (parseInt(`${val}`) - 1) * this.dataParams.offset;
      this.getTableList();

    },
    deletGoods(item, index) {
      this.additionParents.splice(index, 1);
    },
    addItem() {
      this.multipleSelection.forEach((p) => {
        this.additionParents.push(p);
      });
      this.isShow = false;
      console.log("additionParents", this.additionParents);
    },

    addGoods() {
      this.isShow = true;
      this.getTableList();
    },
    massMoveInSingle(item) {
      this.additionItem = item;
      console.log(item);
      this.additionParents = [];
      this.additionParents = JSON.parse(JSON.stringify(item.additionParents));
      this.dialogTableVisibleTwo = true;
      console.log(this.additionParents);
    },
    // 移入套餐
    updateComponent(item, index) {
      console.log(item)
      let params = {
        cusCode: item.cusCode,
        component: this.type == 0 ? false : true,
        userId: item.userId,
        storeId: item.storeId
      }

      let text = this.type == 0 ? this.$t('other.a2581') : this.$t('other.a2582')

      this.$confirm(text, this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a145'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
      }).then(() => {

        userStoreItemsApi
          .updataComponent(params)
          .then(res => {
            if (res.code === 200) {
              let dexc = this.type == 0 ? this.$t('other.a2583') : this.$t('other.a2584')
              this.$message.success(dexc)

              this.ruleForm.storeItems.splice(index, 1)
            } else {
              this.$message.warning(res.msg)
            }
          })

      })
    },
    removeItem() {
      if (this.multipleSelection) {
        this.ruleForm.storeItems.forEach((p, index) => {
          this.multipleSelection.forEach(i => {
            if (p.cusCode == i.cusCode) {
              this.ruleForm.storeItems.splice(index, 1)
            }
          })
        })
      }
    },

    massMoveIn() {
      let arr = []
      this.multipleSelection.forEach((i, index) => {

        arr.push({
          cusCode: i.cusCode,
          component: false,
          userId: i.userId,
          storeId: i.storeId
        })



      })
      let text = this.$t('other.a1059') + arr.length + this.$t('other.a2585')
      this.$confirm(text, this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a145'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
      }).then(() => {
        let total = 0
        console.log(arr)
        arr.forEach(p => {
          userStoreItemsApi
            .updataComponent(p)
            .then(res => {
              console.log(res)
              if (res.code === 200) {
                total += 1
                if (total == arr.length) {
                  this.$message.success(this.$t('other.a2586'))
                  this.removeItem()
                }
                console.log('total', total)
              } else {
                this.$message.warning(res.msg)
              }
            })
        })
      })
    },
    massDeletd() {
      let arr = []
      let num = 0
      this.multipleSelection.forEach(p => {

        arr.push({
          cusCode: p.cusCode,
          userId: this.userId,
          storeId: p.storeId
        })


      })



      console.log(arr)
      let desc = this.$t('other.a2587') + arr.length + this.$t('other.a2588')
      this.$confirm(desc, this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a145'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
      }).then(() => {
        this.listErrorOptions = []
        userStoreItemsApi
          .massDeleteStoreItem(arr)
          .then(res => {
            if (res.code === 200) {

              res.data.forEach(p => {
                if (p.code == 0) {

                } else {

                  this.listErrorOptions.push({
                    cusCode: p.cusCode,
                    desc: p.msg,
                    storeItem: p.storeItem
                  })
                  this.showErrorDeleteItem = true
                  console.log('删除失败的库存产品', this.listErrorOptions)

                }
              })

              if (!this.listErrorOptions.length) {
                this.$message.success(this.$t('other.a565'))
                this.removeItem()
              }

            }
          })

      })
    },

    saveClickvariationName(index, row) {
      row.variationName = row.variationName.trim()
      if (row.variationName.length > 32) {
        this.$message.warning(this.$t('other.a2579'))
        return
      }
      console.log(row.variationName.length)
      this.sellerUpdateStoreItem(row).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('other.a2580'))
        } else {
          this.$message.warning(res.msg)
        }
      })
      row.nameChecked = false
      this.$set(this.ruleForm.storeItems, index, row)
    },

    saveCost(index, row) {
      let patten = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g

      if (!patten.test(row.cost)) {
        this.$message.warning(this.$t('other.a2578'))
        row.cost = 0
        return
      }

      console.log(row.cost)
      this.sellerUpdateStoreItemDetail(row).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('other.a2589'))
        } else {
          this.$message.warning(res.msg)
        }
      })
      row.costChecked = false
      this.$set(this.ruleForm.storeItems, index, row)
    },

    editClick(index, row) {
      console.log(index, row)
      row.skuNameChecked = true
      this.$set(this.ruleForm.storeItems, index, row)
    },
    editvaritionNmae(index, row) {
      console.log(index, row)
      row.nameChecked = true
      this.$set(this.ruleForm.storeItems, index, row)
    },
    editcost(index, row) {
      console.log(index, row)
      row.costChecked = true
      this.$set(this.ruleForm.storeItems, index, row)
    },
    saveDefaultActivityPrice(index, row) {
      let patten = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g

      if (!patten.test(row.defaultActivityPrice)) {
        this.$message.warning(this.$t('other.a2578'))
        row.defaultActivityPrice = 0
        return
      }
      let formData = new FormData()
      formData.append('cusCode', row.cusCode)
      formData.append('defaultActivityPrice', row.defaultActivityPrice)
      userStoreItemsApi.updateDefaultActivityPrice(formData).then(res => {
        if (res.code === 200) {
          this.$message.success('成功修改目标活动价')
        } else {
          this.$message.warning(res.msg)
        }
      })
      row.defaultActivityPriceChecked = false
      this.$set(this.ruleForm.storeItems, index, row)
    },
    searchTemu() {
      this.activityList = [];
      let formData = new FormData()
      formData.append('shopId', this.searchShopId)
      userStoreItemsApi.getMarketingActivityList(formData).then(res => {
        console.log(res, '===>res')
        if (res.success) {
          let arr = []
          for (let i = 0; i < res.result.activityList.length; i++) {
            if (res.result.activityList[i].thematicList && res.result.activityList[i].thematicList.length > 0) {
              arr.push({
                activityThematicName: res.result.activityList[i].activityName,
                hidde: true
              })
            } else {
              arr.push({
                "groupId": this.ruleForm.groupId, //小组ID
                "activityThematicName": res.result.activityList[i].activityName,
                "activityType": res.result.activityList[i].activityType, //活动类型 1-秒杀 5-官方大促 27-清仓	活动专题id，大促进阶使用 13-大促进阶（专题）
              })
            }
            for (let j = 0; j < res.result.activityList[i].thematicList.length; j++) {
              let obj = {
                "groupId": this.ruleForm.groupId, //小组ID
                "activityThematicId": res.result.activityList[i].thematicList[j].activityThematicId, //活动主题id
                "activityThematicName": res.result.activityList[i].thematicList[j].activityThematicName, //活动主题名称
                "activityType": res.result.activityList[i].activityType, //活动类型 1-秒杀 5-官方大促 27-清仓	活动专题id，大促进阶使用 13-大促进阶（专题）
                "startTime": res.result.activityList[i].thematicList[j].startTime, //活动开始时间
                "endTime": res.result.activityList[i].thematicList[j].endTime, //活动结束时间
                "durationDays": res.result.activityList[i].thematicList[j].durationDays,
                "status": 0 //活动状态
              }
              arr.push(obj)
            }
          }
          this.activityList = arr;
          if (this.ruleForm.activityInfoList && this.ruleForm.activityInfoList.length > 0) {
            let arrIds = this.ruleForm.activityInfoList.map((item) => {
              return item.activityThematicName
            })
            this.$nextTick(() => {
              this.$refs.multipleActivityTable.clearSelection();
              arr.forEach(row => {
                if (arrIds.indexOf(row.activityThematicName) != -1) {
                  this.$refs.multipleActivityTable.toggleRowSelection(row, true);
                }
              });
            })
          }
        } else {
          this.$message.warning(res.errorMsg)
        }
      })
    },
    editDefaultActivityPrice(index, row) {
      console.log(index, row)
      row.defaultActivityPriceChecked = true
      this.$set(this.ruleForm.storeItems, index, row)
    },
    autoActivityChange() {
      console.log(this.ruleForm, 'this.ruleForm')
      let data = JSON.parse(JSON.stringify(this.ruleForm))
      data.autoActivitySPU = data.autoActivitySPU ? data.autoActivitySPU.replace(/\n/g, ',') : ''
      if (data.activityInfoList) {
        let arr = [];
        for (let i = 0; i < data.activityInfoList.length; i++) {
          if (!data.activityInfoList[i].hidde) {
            arr.push(data.activityInfoList[i])
          }
        }
        data.activityInfoList = arr;
      }
      userStoreItemsApi.setAutoActivity(data).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('other.a231'))
        } else {
          this.ruleForm.autoActivity = !this.ruleForm.autoActivity
          this.$message.warning(res.msg)
        }
      })
    },
    handleInput(value) {
      // 只允许数字输入
      this.ruleForm.autoActivitySPU = value.replace(/[^\d\n]/g, '');
    },
    submitActivity() {
      let data = JSON.parse(JSON.stringify(this.ruleForm))
      data.autoActivitySPU = data.autoActivitySPU ? data.autoActivitySPU.replace(/\n/g, ',') : null
      if (data.autoActivitySPU) {
        let arr = JSON.parse(JSON.stringify(data.autoActivitySPU)).split(',')
        let arr1 = []
        for (let i = 0; i < arr.length > 0; i++) {
          if (arr[i].trim()) {
            arr1.push(arr[i].trim())
          }
        }
        data.autoActivitySPU = arr1.join(',')
      }
      if (this.multipleActivitySelection && this.multipleActivitySelection.length > 0) {
        let arr = []
        for (let i = 0; i < this.multipleActivitySelection.length; i++) {
          if (!this.multipleActivitySelection[i].hidde) {
            arr.push(this.multipleActivitySelection[i]);
          }
        }
        data.activityInfoList = arr;
        this.ruleForm.activityInfoList = data.activityInfoList;
      }
      userStoreItemsApi.setAutoActivity(data).then(res => {
        if (res.code === 200) {
          this.$message.success(this.$t('other.a231'))
          this.activityListShow = false;
          this.activitySPUShow = false;
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    openActivityList() {
      this.activityListShow = true;
      this.activityList = [];
      let formData = new FormData()
      formData.append('shopId', this.searchShopId)
      userStoreItemsApi.getMarketingActivityList(formData).then(res => {
        console.log(res, '===>res')
        if (res.success) {
          let arr = []
          for (let i = 0; i < res.result.activityList.length; i++) {
            if (res.result.activityList[i].thematicList && res.result.activityList[i].thematicList.length > 0) {
              arr.push({
                activityThematicName: res.result.activityList[i].activityName,
                hidde: true
              })
            } else {
              arr.push({
                "groupId": this.ruleForm.groupId, //小组ID
                "activityThematicName": res.result.activityList[i].activityName,
                "activityType": res.result.activityList[i].activityType, //活动类型 1-秒杀 5-官方大促 27-清仓	活动专题id，大促进阶使用 13-大促进阶（专题）
              })
            }
            for (let j = 0; j < res.result.activityList[i].thematicList.length; j++) {
              let obj = {
                "groupId": this.ruleForm.groupId, //小组ID
                "activityThematicId": res.result.activityList[i].thematicList[j].activityThematicId, //活动主题id
                "activityThematicName": res.result.activityList[i].thematicList[j].activityThematicName, //活动主题名称
                "activityType": res.result.activityList[i].activityType, //活动类型 1-秒杀 5-官方大促 27-清仓	活动专题id，大促进阶使用 13-大促进阶（专题）
                "startTime": res.result.activityList[i].thematicList[j].startTime, //活动开始时间
                "endTime": res.result.activityList[i].thematicList[j].endTime, //活动结束时间
                "durationDays": res.result.activityList[i].thematicList[j].durationDays,
                "status": 0 //活动状态
              }
              arr.push(obj)
            }
          }
          this.activityList = arr;
          console.log(1111)
          if (this.ruleForm.activityInfoList && this.ruleForm.activityInfoList.length > 0) {
            let arrIds = this.ruleForm.activityInfoList.map((item) => {
              return item.activityThematicName
            })
            this.$nextTick(() => {
              this.$refs.multipleActivityTable.clearSelection();
              arr.forEach(row => {
                if (arrIds.indexOf(row.activityThematicName) != -1) {
                  this.$refs.multipleActivityTable.toggleRowSelection(row, true);
                }
              });
            })
          }
        } else {
          this.$message.warning(res.errorMsg)
        }
      })
    },
    openActivitySPU() {
      this.activitySPUShow = true;
    },
    rowcb(row) {
      if (row.row.hidde) {  // 第一列是选择列
        return "hide-row"
      }
    },
    cellcb(row) {
      if (row.row.hidde && row.columnIndex == 0) {  // 第一列是选择列
        return "hide-checkbox"
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (row.hidde) {
        return [1, 2]
      }
    },
    checkSelectable(row, index) {
      console.log(row, '======>row')
      return false
    },
    // 更新成本价货源
    updataCostAndSupply(item, num) {
      if (num == 1 && item.supply.length > 120) {
        this.$message.warning(this.$t('other.a2590'))
        item.supply = null
        return
      }
      item.userId = this.userId
      item.supply = item.supply == '' ? null : item.supply
      item.cost = item.cost == '' ? item.cost : item.cost
      userStoreItemsApi
        .buyerUpdateCost(item)
        .then(res => {
          if (res.code === 200) {
            console.log('desc', res.data)
            this.$message.success(this.$t('other.a2591'))
            item.checked = false
            item.checked02 = false
          } else {
            this.$message.warning(res.msg)
          }
        })

    },
    handleAvatarSuccess(res, file) {
      console.log(res, file)
      this.imageUrl = URL.createObjectURL(file.raw);
      this.changePicObj.image = res.data

      console.log('imageUrl', res.data)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isLt2M = file.size / 1024 / 1024 < 10;

      if (!isJPG) {
        this.$message.error(this.$t('other.a2592'));
      }
      if (!isLt2M) {
        this.$message.error(this.$t("other.a333"));
      }
      return isJPG && isLt2M;
    },

    submitCoding() {
      console.log(this.barCode)
      if (!this.barCode) {
        this.$message.warning(this.$t('other.a2593'))
        return
      }


      let obj = JSON.parse(JSON.stringify(this.itemCoding))
      obj.encoding = this.barCode.trim()
      obj.userId = this.userId

      userStoreItemsApi
        .updateEncoding(obj)
        .then(res => {
          if (res.code == 200) {
            this.$message.success(this.$t('other.a2594'))
            this.productCode = false
            this.itemCoding.encoding = JSON.parse(JSON.stringify(this.barCode))
            this.barCode = ''
          } else {
            this.$message.warning(res.msg)
          }
        })
    },

    changeLockStock(item) {
      console.log(item)
      let param = {
        autoReserved: item.autoReserved,
        userId: this.userId,
        cusCode: item.cusCode,
        storeId: item.storeId
      }
      item.autoReserved = !item.autoReserved
      if (!item.autoReserved) {
        this.$confirm(this.$t('other.a2595'), this.$t("other.a142"), {
          confirmButtonText: this.$t('other.a145'),
          cancelButtonText: this.$t('other.a146'),
          type: 'warning'
        }).then(() => {
          item.autoReserved = true
          param.autoReserved = true
          console.log(param)
          api
            .updateAutoReserved(param)
            .then(res => {
              if (res.code === 200) {
                this.$message.success(this.$t('other.a2596'))
                this.getDataByGroupId()
              }
            })
        })

      } else {
        this.$confirm(this.$t('other.a2597'), this.$t("other.a142"), {
          confirmButtonText: this.$t('other.a145'),
          cancelButtonText: this.$t('other.a146'),
          type: 'warning'
        }).then(() => {
          item.autoReserved = false
          param.autoReserved = false
          console.log(param)

          api
            .updateAutoReserved(param)
            .then(res => {
              if (res.code === 200) {
                this.$message.warning(this.$t('other.a2598'))
                this.getDataByGroupId()
              }
            })
        })
      }


    },

    updateShopeeItem(item) {
      item.synchrony = !item.synchrony
      if (!item.synchrony) {
        let text = this.$t('other.a2599')
        this.$confirm(text, this.$t("other.a142"), {
          confirmButtonText: this.$t('other.a763'),
          cancelButtonText: this.$t('other.a146'),
          type: 'warning'
        }).then(() => {
          let ttp = JSON.parse(JSON.stringify(item))
          ttp.synchrony = true
          userStoreItemsApi
            .sellerUpdateSynchrony(ttp)
            .then(res => {
              if (res.code === 200) {
                console.log('desc', res.data)
                this.$message.success(this.$t('other.a2600'))
                item.synchrony = true
              } else {
                this.$message.warning(res.msg)
              }
            })

        })
      } else {
        let text = this.$t('other.a2601')
        this.$confirm(text, this.$t("other.a142"), {
          confirmButtonText: this.$t('other.a5'),
          cancelButtonText: this.$t('other.a146'),
          type: 'warning'
        }).then(() => {
          let ttp = JSON.parse(JSON.stringify(item))
          ttp.synchrony = false
          userStoreItemsApi
            .sellerUpdateSynchrony(ttp)
            .then(res => {
              if (res.code === 200) {
                console.log('desc', res.data)
                this.$message.success(this.$t('other.a2602'))
                item.synchrony = false
              } else {
                this.$message.warning(res.msg)
              }
            })
        })
      }


    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
      console.log('multipleSelection', this.multipleSelection)
    },
    handleSelectionActivityChange(val) {
      // this.ruleForm.activityInfoList = val;
      this.multipleActivitySelection = val;
      console.log('multipleActivitySelection', this.multipleActivitySelection)
    },

    tableRowClassName({ row, rowIndex }) {
      let ttp = this.$route.query.cusCode
      if (ttp) {
        ttp = ttp.trim()
      }

      if (row.cusCode == ttp || row.skuName.indexOf(ttp) > -1) {
        return 'warning-row';
      }
      return '';
    },




    init() {
      if (this.$route.query.groupId) {
        this.type = this.$route.query.type
        this.getDataByGroupId()
      }
    },

    getDataByGroupId() {
      api
        .getStoreItemByGroupId({
          groupId: this.$route.query.groupId
        })
        .then(res => {
          if (res.code === 200) {
            let type = Number(this.$route.query.type)

            console.log(type)
            let list = []
            console.log('desc', res.data)
            this.warehouseId = res.data.storeId
            res.data.checked = false
            res.data.boundNum = 0

            res.data.storeItems.forEach((p, index) => {
              p.reservedStockCopy = 0
              p.reservedStockTotal = 0
              p.assibleUnshiped = 0
              p.checked = false
              p.checked02 = false
              p.checked_one = false
              p.skuNameChecked = false
              p.costChecked = false
              p.defaultActivityPriceChecked = false
              p.skuChecked = false
              if (p.itemNum > 0) {
                res.data.boundNum++
              }

              if (p.parents !== null) {
                if (p.parents.length) {
                  p.parents.forEach(j => {
                    p.reservedStockCopy += j.rate * j.reservedStock
                    p.assibleUnshiped += j.rate * j.unShipped
                  })

                }
              }
              p.reservedStockTotal = p.reservedStockCopy + p.reservedStock
              if (type == 0 && p.component) {
                list.push(p)
              }

              if (type == 1 && !p.component) {
                list.push(p)
              }

              if (type == 2 && p.addition) {
                list.push(p)
              }



            })
            let target = this.$route.query.cusCode
            let that = this
            if (target) {
              target = target.trim()
              //  let num=list.findIndex(item => item.cusCode == target || item.skuName.indexOf(target)  !== -1 )
              let list2 = []
              list.forEach(p => {
                if (p.cusCode == target || that.matchStoreDesc(target, p.skuName)) {
                  list2.push(p)
                }

              })
              //  console.log('num',num)
              //  let arr=list.splice(num, 1)
              //  list.unshift(arr[0])
              console.log('list2', list2)
              list = list2

            }

            res.data.storeItems = list
            res.data.autoActivitySPU = res.data.autoActivitySPU ? res.data.autoActivitySPU.replace(/,/g, '\n') : res.data.autoActivitySPU

            this.ruleForm = res.data
            console.log('ruleForm', this.ruleForm)
            console.log('list', list)
          } else {
            this.$message.warning(res.msg)
          }
        })
    },


    matchStoreDesc(target, text) {
      let a = target; //用户输入的字符串
      let str = ['', ...a, ''].join('.*'); //转化成正则格式的字符串
      let reg = new RegExp(str) //正则
      return reg.test(text) //去匹配待查询的字符串
      console.log('injgn', reg.test(text))

    },


    goBack() {
      if (this.$route.query.type == 0) {
        this.$router.push('/stockProduct/single')
      } else if (this.$route.query.type == 1) {
        this.$router.push('/stockProduct/combo')
      } else if (this.$route.query.type == 2) {
        this.$router.push('/stockProduct/gift')
      }
    },

    bindItem(item) {
      console.log(item)
      mygoods
        .getBindItems({
          cusCode: item.cusCode
        })
        .then(res => {
          if (res.code === 200) {
            console.log('desc', res.data)
            this.onlineItems = {
              sku: item,
              list: res.data,
              storeId: this.ruleForm.storeId
            }
            this.showProduct = true
          } else {
            this.$message.warning(res.msg)
          }
        })
    },

    viewstoreoperaterecord(item) {
      this.instockdia = true
      this.maincusCode = item.cusCode
      let params = {
        cusCode: item.cusCode,
        end: utils.CurdateAddoneday(utils.getRecentDays(0)),
        start: utils.getRecentDays(-7),
        offset: 50,
        page: 0,
        userId: this.userId
      }
      console.log(params)
      this.getInstockoperaterecore(params)
    },

    deleStoreItem(item, index) {
      this.$confirm(this.$t('other.a2157'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a145'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
      }).then(() => {
        let param = {
          cusCode: item.cusCode,
          userId: this.userId,
          storeId: item.storeId
        }

        this.deleStoreItems(param).then(res => {
          if (res.code == 200) {
            if (res.data.code == 0) {
              this.$message.success(res.data.msg)
              this.ruleForm.storeItems.splice(index, 1)
            } else {
              this.$message.warning(this.$t('other.a2603') + res.data.msg)
            }
          }

        })

      })

    },










  }
}

</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";

/deep/ .el-dropdown-menu__item {
  font-size: 22px;
  line-height: 45px;
}

/deep/ .el-table .warning-row {
  background: oldlace;
}



.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;

  border: 1px solid #000;
  border-radius: 5px;
}


.avatar {
  width: 178px;
  height: 178px;
  display: block;
}

.upload__tip {
  font-size: 20px;
}

.ogitg {
  margin: 20px;
  font-size: 16px;
  font-weight: bold;
  color: #757575;
}

.stockProduct_box {
  background-color: rgba(226, 222, 222, 0.5);
  min-height: 100vh;



  .el-icon-edit {
    cursor: pointer;
    color: #409EFF;
    font-size: 18px;
    margin-left: 10px;
  }

  .kvhkfn {
    color: #409EFF;
    cursor: pointer;
    width: 150px;
    text-align: center;
  }


  .header_tip {
    background: #fff;

    padding: 6px 0;

    .ivmfjn {
      display: flex;
      align-items: center;
      padding-left: 15px
    }


  }

  .menu {
    margin-right: 20px;
  }



  .basic_info {

    background-color: #fff;
    padding: 0 16px;
    margin: 35px 10px 10px 10px;


    .skuDesc {
      font-size: 18px;
      font-weight: bold;
      margin: 20px 10px;
    }

    .itemskuImg {
      width: 150px;
      height: 150px;
      border: 1px solid #eee;
      border-radius: 3px;
      overflow: hidden;



      img {
        width: 100%;
      }
    }

    .el-icon-edit-outline {
      font-size: 17px;
      margin-left: 15px;
      color: #409EFF;
      cursor: pointer;
    }

    .lknf {
      font-size: 17px;
      margin-left: 15px;
      color: #409EFF;
      cursor: pointer;
    }

    .btn {
      margin: 3px 0;


    }

    .pic_box {
      width: 80px;
      height: 80px;
      border: 1px solid #eee;
      overflow: hidden;
      border-radius: 5px;
    }

    .title {
      height: 40px;
      line-height: 40px;
      font-size: 20px;
      font-weight: 500;
      letter-spacing: .02em !important;
      font-family: Roboto, sans-serif !important;
      border-bottom: 1px solid #eee;
    }

    .basic_detail {
      padding: 15px 0;

    }

  }






  .check_desc {
    @include flex-between();
    margin: 10px 0;
    padding-right: 20px;


  }

  .check_Top {
    position: fixed;
    z-index: 99;
    top: 50px;
    width: calc(100% - 205px);
    background-color: #fff;
    border-bottom: 1px solid #eee;


  }



}

.oneMore {
  max-width: 45%;
  /* 设置合适的宽度 */
  white-space: nowrap;
  /* 强制不换行 */
  overflow: hidden;
  /* 超出隐藏 */
  text-overflow: ellipsis;
  /* 显示省略号 */
  text-align: left;
  padding-top: 0 !important;

  /deep/span {
    display: inline-block;
    width: 100%;
    /* 设置合适的宽度 */
    white-space: nowrap;
    /* 强制不换行 */
    overflow: hidden;
    /* 超出隐藏 */
    text-overflow: ellipsis;
  }
}

.oneText {
  max-width: 90%;
  text-align: left;
  padding-top: 0 !important;

  /deep/span {
    display: inline-block;
    width: 100%;
    white-space: wrap;
  }
}

/deep/.hide-row {
  background-color: #F5F7FA;

  .hide-checkbox {
    display: none;
  }
}
</style>